import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyResponse, SurveyOption } from '@nx-c4g/c4g-models';
import { BaseSurveyStepComponent } from '../base-survey-step/base-survey-step.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'c4g-survey-step-information',
  standalone: true,
  encapsulation: ViewEncapsulation.ShadowDom,
  imports: [CommonModule],
  templateUrl: './information-survey-step.component.html',
  styleUrls: ['./information-survey-step.component.scss']
})
export class InformationSurveyStepComponent extends BaseSurveyStepComponent {
  currentPage = 0;
  readonly pageSize = 4;

  constructor(
    @Inject('stepData') stepData: any,
    @Inject('stepResponse') stepResponse: any,
    @Inject('initialStepResponse') initialStepResponse: any,
    public translate: TranslateService
  ) {
    super(stepData, stepResponse, initialStepResponse);
  }

  get pagedOptions(): SurveyOption[] {
    const start = this.currentPage * this.pageSize;
    return this.stepData?.options?.slice(start, start + this.pageSize) || [];
  }

  get allOptionsShown(): boolean {
    return (this.currentPage + 1) * this.pageSize >= (this.stepData?.options?.length || 0);
  }

  onSeeMore() {
    if (!this.allOptionsShown) {
      this.currentPage++;
    }
  }

  getLangValue(mls: { en: string; fr: string }): string {
    const lang = this.translate.currentLang === 'fr' ? 'fr' : 'en';
    return mls?.[lang] || mls?.['en'] || '';
  }

  override async getResponse(): Promise<SurveyResponse | undefined> {
    // Use this.stepData and this.emitResponse in your logic
    // Implement your logic here
    return undefined;
  }
}
